// Shared inline styles for the mailing pages and cards.
export const mailingCardStyle = {
  background: 'white',
  padding: '2rem',
  borderRadius: '12px',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  maxWidth: 560,
  margin: '0 auto',
};

export const mailingButtonStyle = {
  display: 'inline-block',
  padding: '0.65rem 1.5rem',
  background: '#1a1a1a',
  color: 'white',
  border: '1px solid #1a1a1a',
  borderRadius: '999px',
  textDecoration: 'none',
  fontSize: '0.95rem',
  fontWeight: 600,
  cursor: 'pointer',
};

export const mailingLinkButtonStyle = {
  background: 'none',
  border: 'none',
  padding: 0,
  color: '#666',
  textDecoration: 'underline',
  fontSize: '0.9rem',
  cursor: 'pointer',
};
